import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, Calendar, Bell, Users, Settings, LogOut, FileText, BookOpen, Newspaper, Menu, X } from 'lucide-react';
import { useState } from 'react';

const AdminLayout = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/admin/login');
        } catch (error) {
            console.error("Çıkış yapılırken hata oluştu:", error);
        }
    };

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setIsSidebarOpen(false);

    const menuItems = [
        { path: '/admin', icon: LayoutDashboard, label: 'Panel' },
        { path: '/admin/events', icon: Calendar, label: 'Etkinlikler' },
        { path: '/admin/announcements', icon: Bell, label: 'Duyurular' },
        { path: '/admin/blogs', icon: FileText, label: 'Köşe Yazıları' },
        { path: '/admin/magazines', icon: BookOpen, label: 'Dergimiz' },
        { path: '/admin/press', icon: Newspaper, label: 'Basında Biz' },
        { path: '/admin/team', icon: Users, label: 'Ekip Üyeleri' },
        { path: '/admin/backup', icon: Settings, label: 'Yedekleme' },
    ];

    return (
        <div className="flex h-screen bg-gray-900 text-gray-100 font-sans overflow-hidden">
            {/* Mobile Menu Button - Fixed Top Left */}
            <div className="md:hidden fixed top-4 left-4 z-50">
                <button
                    onClick={toggleSidebar}
                    className="p-2 bg-gray-800 rounded-lg shadow-lg border border-gray-700 text-cyan-400"
                >
                    {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Overlay for Mobile */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 md:hidden backdrop-blur-sm"
                    onClick={closeSidebar}
                />
            )}

            {/* Sidebar */}
            <aside
                className={`
                    fixed md:static inset-y-0 left-0 z-50
                    w-64 bg-gray-800 border-r border-gray-700 flex flex-col
                    transform transition-transform duration-300 ease-in-out
                    ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
                    shadow-2xl md:shadow-none
                `}
            >
                <div className="p-6 border-b border-gray-700 flex justify-between items-center bg-gray-800">
                    <h1 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
                        TURET Admin
                    </h1>
                    {/* Close button inside sidebar for mobile convenience */}
                    <button onClick={closeSidebar} className="md:hidden text-gray-400 hover:text-white">
                        <X size={20} />
                    </button>
                </div>

                <nav className="flex-1 p-4 space-y-2 overflow-y-auto custom-scrollbar">
                    {menuItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = location.pathname === item.path;

                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                onClick={closeSidebar} // Close sidebar on navigation on mobile
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${isActive
                                    ? 'bg-cyan-500/10 text-cyan-400 border border-cyan-500/20'
                                    : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                                    }`}
                            >
                                <Icon size={20} />
                                <span className="font-medium">{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>

                <div className="p-4 border-t border-gray-700 bg-gray-800/50">
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 w-full px-4 py-3 text-red-400 hover:bg-red-500/10 rounded-lg transition-colors"
                    >
                        <LogOut size={20} />
                        <span className="font-medium">Çıkış Yap</span>
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 overflow-auto bg-gray-900 p-4 md:p-8 pt-20 md:pt-8 w-full relative">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
